import request from '../common/request.js';

//获取token
export function GetToken(payload) {
    return request.post('/OAuth2/GetToken', payload);
}

//身份验证
export function Auth(payload) {
    return request.post('/Plat/Login/Auth', payload);
}

// https://syapi.shsyzn.com.cn/Plat/Login/Auth